import EBarManageEmailsCTA from './EBarManageEmailsCTA';

export default EBarManageEmailsCTA;
